import React, { createContext, useState } from 'react';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [title, setTitle] = useState('სსიპ ბაზარზე ზედამხედველობის სააგენტო');
  const [headerType, setHeaderType] = useState(2);
  const [image, setImage] = useState('');

  return (
    <AppContext.Provider
      value={{ title, image, setImage, setTitle, headerType, setHeaderType }}
    >
      {children}
    </AppContext.Provider>
  );
};
